export const ownerNameError = (v) => {
  const s = v || "";
  if (s.length > 40) return "Owner's name can be at most 40 characters";
  if (!/^[A-Za-z ]*$/.test(s)) return "Owner's name can contain only letters and spaces";
  return "";
};
